export const ActivitiesController = {
    index(): void {},
    show(): void {},
};
